import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap'
const Footer = (props) => {
  // Obtiene la fecha actual
  const currentDate = new Date().getFullYear();
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md="12" className="footer-copyright text-center">
              <p className="mb-0">{"Copyright "+ currentDate +" © Plataforma "} <a href="https://www.montierp.com/">MonTiErp</a> {"- E-Learning "}</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
}

export default Footer;